import PropTypes from "prop-types";
import { IconButton, Typography } from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useKeikkaData } from "src/context/KeikkaDataContext";

const styles = {
  height45: { height: "45px" },
  pointer: { cursor: "pointer" },
};

export default function KeikkaOtsikkoLabel(props) {
  const { keikkaData } = useKeikkaData();
  const onEditClick = props.onEditClick;
  const allowEdit = keikkaData.auth.originalEdit;

  return (
    <div className="center" aria-label="Otsikko">
      <Typography
        variant="h7"
        onClick={onEditClick}
        aria-label="Muokkaa otsikkoa"
        color="primary"
        sx={
          (styles.pointer,
          {
            opacity: keikkaData.keikkaOtsikko ? 1 : 0.3,
          })
        }
        className={keikkaData.keikkaOtsikko ? "fixPrint" : "noPrint"}>
        {keikkaData.keikkaOtsikko ? keikkaData.keikkaOtsikko : "tilauksen nimi tai otsikko"}
      </Typography>
      {allowEdit && (
        <>
          <div className="noPrint" style={{ opacity: 0.7 }}>
            <IconButton onClick={onEditClick} size="small" aria-label="Muokkaa otsikkoa">
              <ModeEditOutlineOutlinedIcon
                color="primary"
                fontSize="smaller"
                className="transitionElement"
              />
            </IconButton>
          </div>
        </>
      )}
    </div>
  );
}

KeikkaOtsikkoLabel.propTypes = {
  onEditClick: PropTypes.func,
};
